<template>
  <div>
    <slot :openModal="openModal">
      <button type="button" class="btn btn-primary btn-sm btn-rounded tw-px-3 tw-py-2 tw-flex tw-items-center tw-gap-2"
              @click.prevent.stop="showModal=true"
              v-if="isCustomerProfile">
        <i class="fas fa-pencil" v-if="editMode !== 'password'"></i>
        {{ editButton || 'Edit' }}
      </button>

      <a href="#" @click.prevent.stop="showModal=true" v-else>
        {{ editButton || 'Edit' }}
      </a>
    </slot>

    <b-modal v-model="showModal" :title="modalTitle" hide-footer @hidden="resetForm" size="lg">
      <b-form @submit="handleSubmit">
        <customer-edit-profile-info v-if="editMode === 'customer_profile'"
                                    :user="user"
                                    ref="customerEditProfileInfo"/>

        <edit-password v-else-if="editMode === 'password'"
                       @validPassword="validPassword = arguments[0]"
                       ref="editPassword"/>

        <contributor-edit-profile-info v-else-if="editMode === 'contributor_profile'"
                                       :user="user"
                                       ref="contributorEditProfileInfo"/>

        <b-row class="mt-4 mb-2">
          <b-col class="ml-auto" cols="auto">
            <b-button variant="light"
                      class="btn-rounded px-3"
                      @click="closeModal"
                      :disabled="saving">
              Cancel
            </b-button>
            <b-button variant="primary"
                      class="btn-rounded px-3"
                      type="submit"
                      :disabled="saving || submitFormDisabled">
              <span v-if="saving">Please Wait...</span>
              <span v-else>Save</span>
            </b-button>
          </b-col>
        </b-row>
      </b-form>
    </b-modal>
  </div>
</template>

<script>
import GeneralMixins from "../../../mixins/GeneralMixins";
import EditPassword from "./EditPassword";
import CustomerEditProfileInfo from "./EditProfileInfo";
import ContributorEditProfileInfo from "../../Contributors/Account/EditProfileInfo";

export default {
  components: {CustomerEditProfileInfo, EditPassword, ContributorEditProfileInfo},
  props: ['user', 'usersUrl', 'editButton', 'editMode'],
  mixins: [GeneralMixins],

  data: function () {
    return {
      saving: false,
      showModal: false,
      validPassword: null
    }
  },

  methods: {

    openModal() {
      this.showModal = true;
    },
    params() {
      const form = this.currentEditForm();
      if (form) {
        return form.params;
      }
    },

    handleSubmit(evt) {
      evt.preventDefault();
      this.saving = true;
      this.$http.patch(this.usersUrl, {
        user: this.params()
      }).then(fulfilled => {
        if (this.editMode === 'password') {
          this.showToast("Password was changed successfully")
          this.closeModal();
        } else {
          location.reload()
        }
        this.saving = false;
      }, rejected => {
        this.saving = false;
        this.showErrorToast(this.getErrorMessages(rejected.body, true))
      })
    },

    closeModal() {
      this.showModal = false;
      this.resetForm();
    },

    isCustomerProfile() {
      return this.editMode === 'customer_profile' || this.editMode === 'password';
    },

    currentEditForm() {
      if (this.editMode === 'password') {
        return this.$refs.editPassword;
      } else if (this.editMode === 'customer_profile') {
        return this.$refs.customerEditProfileInfo;
      } else if (this.editMode === 'contributor_profile') {
        return this.$refs.contributorEditProfileInfo;
      }
    },

    resetForm() {
      const form = this.currentEditForm();
      if (form) {
        form.resetForm();
      }
    }
  },

  computed: {
    submitFormDisabled() {
      if (this.editMode === 'password') {
        return !this.validPassword;
      }

      return false
    },
    modalTitle() {
      const titles = {
        customer_profile: 'Edit Profile Information',
        contributor_profile: 'Edit Profile Information',
        password: 'Change Password'
      }
      return titles[this.editMode];
    }
  }
}
</script>